import { Edit } from "react-admin";
import EditSaveForm from "./EditSaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditCampaigns = () => {
  return (
    <Edit
      title="Редакция на предварителна кампания"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <EditSaveForm isEdit />
    </Edit>
  );
};
export default EditCampaigns;
